import { render } from "./VerifyPoints.vue?vue&type=template&id=2ca46fcc&scoped=true"
import script from "./VerifyPoints.vue?vue&type=script&lang=js"
export * from "./VerifyPoints.vue?vue&type=script&lang=js"

import "./VerifyPoints.vue?vue&type=style&index=0&id=2ca46fcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca46fcc"]])

export default __exports__